<template>
  <v-row>
    <v-col cols="12" sm="4">
      <v-select
        v-model="editedItem.meal"
        :error-messages="error.meal"
        :items="[
          { value: 1, text: 'pranzo' },
          { value: 2, text: 'cena' },
        ]"
        :readonly="!profile.is_staff"
        label="Pasto"
      ></v-select>
    </v-col>
    <v-col cols="12" sm="4">
      <date-time-picker
        v-model="editedItem.date"
        :error-messages="error.date"
        label="Data di somministrazione"
        :disabled="!profile.is_staff"
      ></date-time-picker>
    </v-col>
    <v-col cols="12" sm="4">
      <autocomplete
        v-model="editedItem.person"
        :error-messages="error.person"
        :model="showPersonModel"
        :extra-params="modelFk"
        item-text="person__name"
        item-value="id"
        label="Musicisti"
        :readonly="!profile.is_staff"
      ></autocomplete>
    </v-col>
    <v-col cols="12" sm="4">
      <v-text-field
        v-model="editedItem.guests_total"
        :error-messages="error.guests_total"
        label="Ospiti"
        :readonly="!profile.is_staff"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="4" v-if="profile.is_staff">
      <v-text-field
        v-model="editedItem.cost"
        :error-messages="error.cost"
        label="Costo"
      ></v-text-field>
    </v-col>
    <v-col
      v-if="
        profile.is_staff &&
        editedItem.warnings &&
        editedItem.warnings.length > 0
      "
      cols="12"
      sm="4"
    >
      <ul>
        <li
          v-for="(warning, index) in editedItem.warnings"
          :key="index"
          class="red--text"
        >
          <template v-if="warning.type == 'voucher_outside_person_availability_range'">
            Il voucher è all'infuori del range di disponibilità della persona
          </template>
          <template v-else-if="warning.type == 'person_voucher_event_overlap'">
            Il voucher si sovrappone con l'evento {{ warning.event_name }}
          </template>
        </li>
      </ul>
    </v-col>
  </v-row>
</template>

<script>
  import models from "@/models"

  export default {
    props: {
      editedItem: {
        type: Object,
        required: true,
      },
      error: {
        type: Object,
        default: () => ({}),
      },
      modelFk: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        showPersonModel: models.ShowPerson,
      }
    }
  }
  </script>
